module.exports = __webpack_public_path__ + "static/img/587.1bb2b0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/rjzz/587.jpg
// module id = dd/n
// module chunks = 0